<h2 mat-dialog-title>
    Add Competency
    <button class="close-button" (click)="onCancel()" disableRipple>
      <span class="material-symbols-outlined">
        close
        </span>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography custom-dialog">
    <div class="employee-info">
      <div class="employee-header">
        <p><strong style="color: aliceblue;">{{ data.employee.firstName }} {{ data.employee.lastName }}</strong></p>
        <p style="color: aliceblue;">{{ data.employee.employeeId }} | {{ data.employee.emailAddress || 'No email provided' }}</p>
      </div>
    </div>
  
    <div class="row competency-container">
      <!-- Competency Dropdown -->
  <div class="col-6">
    <div class="comments-label">
        Competency <span style="color: red;">*</span>
    </div>
    <div class="dropdown" >
        <mat-form-field class="custom_select">
            <mat-select placeholder="Select Competency" [(value)]="selectedCompetency"
                (selectionChange)="onCompetencyChange()">
                <mat-option *ngFor="let competency of competencies"
                    [value]="competency.id">{{competency.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
  
<!-- Sub-Competency Dropdown -->
  <div class="col-6">
    <div class="comments-label">
      Sub-Competency <span style="color: red;">*</span>
    </div>
    <div class="dropdown">
      <mat-form-field class="custom_select">
        <mat-select 
          placeholder="Select Sub-Competency"
          [(value)]="selectedSubCompetency"
        >
          <mat-option
            *ngFor="let subCompetency of subCompetencies"
            [value]="subCompetency.id"
          >{{subCompetency.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
    </div>
    <div class="comments-section w-100">
      <label for="comments" class="comments-label">Comments:</label>
      <textarea 
        id="comments"
        placeholder="Enter comments here..."
        class="comments-input"
        [(ngModel)]="comments"
      ></textarea>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" class="custom-dialog-actions">
    <button class="btn btn-outline btn-spacing" style="border: 2px solid #1976D2;" (click)="onCancel()">Cancel</button>
    <button class="btn btn-primary" style="background: #1976D2; color: white;" (click)="onSave(data.employee.employeeId)">Submit</button>
  </mat-dialog-actions>
  